import { Directive,Input, ElementRef, HostListener , Renderer2, input } from '@angular/core';
@Directive({ selector: '[appTwoDigitDecimaNumber]' })



export class TwoDigitDecimaNumberDirective {
  @Input() beforeDecimal:any = ''
  @Input() afterDecimal:any = ''
  a:string='^\\d{0,';
  b:string='}(?:\\.\\d{0,';
  c:string='})?$';

  private regex: RegExp = new RegExp(/^\d{0,4}(?:\.\d{0,5})?$/);
  private specialKeys: Array<string> = ['Backspace', 'Tab','End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  // tslint:disable-next-line:typedef
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let  regex: RegExp = new RegExp(this.a+this.beforeDecimal+this.b+this.afterDecimal+this.c);
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(regex)) {
      event.preventDefault();
    }
  }
}
@Directive({ selector: '[appCommonDigitsDirective]' })
export class CommonDigitsDirective {
  @Input() beforeDecimal:any = ''
  @Input() afterDecimal:any = ''
  @Input() pricingOptions:any = ''
  @Input() commodityType:any = ''
  a1:string='^[+-]?\\d{0,';
  a:string='^\\d{0,';
  b:string='}(?:\\.\\d{0,';
  c:string='})?$';
  private regex: RegExp = new RegExp(/^\d{0,4}(?:\.\d{0,5})?$/);
  
  private specialKeys: Array<string> = ['Backspace', 'Tab','End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  // tslint:disable-next-line:typedef
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let regex:RegExp;
    if((this.commodityType == 'IO' || this.commodityType == 'CA') &&
     (this.pricingOptions!="FIXED_PRICE")){
      regex = new RegExp(this.a1+this.beforeDecimal+this.b+this.afterDecimal+this.c);
    }
    else{
      regex = new RegExp(this.a+this.beforeDecimal+this.b+this.afterDecimal+this.c);
    }
    
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(regex)) {
      event.preventDefault();
    }
  }
}
@Directive({ selector: '[appAllowNegativeDecimalNumber]' })
export class AllowNegativeDecimalNumber {
  @Input() beforeDecimal:any = ''
  @Input() afterDecimal:any = ''
  a:string='^[+-]?\\d{0,';
  b:string='}(?:\\.\\d{0,';
  c:string='})?$';
  private regex: RegExp = new RegExp(/^[+-]?\d{0,4}(?:\.\d{0,5})?$/);
  private specialKeys: Array<string> = ['Backspace', 'Tab','End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  // tslint:disable-next-line:typedef
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let  regex: RegExp = new RegExp(this.a+this.beforeDecimal+this.b+this.afterDecimal+this.c);
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(regex)) {
      event.preventDefault();
    }
  }
}
@Directive({ selector: '[restrictDecimaNumber]' })
export class restrictDecimaNumberDirective {
  private regex: RegExp = new RegExp(/^\d*?\d{0}$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  // tslint:disable-next-line:typedef
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[allowPositiveAndNegativeNumbers]' })

export class allowPositiveAndNegativeNumbersDirective {
  private regex: RegExp = new RegExp(/^[+-]?\d*?\d{0}$/g); //^-?\d+$
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  // tslint:disable-next-line:typedef
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}

@Directive({ selector: '[preventCutCopyPaste]' })

export class CopyDirective {
    constructor(el: ElementRef, renderer: Renderer2) {
      const events = 'cut copy paste';
      events.split(' ').forEach(e =>
      renderer.listen(el.nativeElement, e, (event) => {
        event.preventDefault();
        })
      );

    }
}
@Directive({ selector: '[appPositiveNegativeDecimalNumber]' })
export class PositiveNegativeDecimalNumberDirective {
  @Input() beforeDecimal:any = ''
  @Input() afterDecimal:any = ''
  @Input() numberType:any = ''
    @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    // Prevent decimal point if afterDecimal is 0
    if (event.key === '.' && this.afterDecimal === '0') {
      event.preventDefault();
    }
  }
  a1:string='^[+-]?\\d{0,';
  a:string='^\\d{0,';
  b:string='}(?:\\.\\d{0,';
  c:string='})?$';
  private regex: RegExp = new RegExp(/^\d{0,4}(?:\.\d{0,5})?$/);
  
  private specialKeys: Array<string> = ['Backspace', 'Tab','End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  // tslint:disable-next-line:typedef
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let regex:RegExp;
    if(this.numberType == 'negative'){
      regex = new RegExp(this.a1+this.beforeDecimal+this.b+this.afterDecimal+this.c);
    }
    else{
      regex = new RegExp(this.a+this.beforeDecimal+this.b+this.afterDecimal+this.c);
    }
    
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(regex)) {
      event.preventDefault();
    }
  }
}


